export class Price {
  base: PriceDetail;
  final: PriceDetail;
  building: number;
  discount: any;
}

export class PriceDetail {
  netto: number;
  brutto: number;
}
